import {mapActions, mapState} from "vuex";
import notifyMessages from "./notifyMessages";

export default {

  mixins: [ notifyMessages ],

  methods: {
    ...mapActions({
      deleteResource: 'booleanSearch/deleteResource',
    }),

    remove({key, item}) {
      return new Promise((resolve, reject) => {
        this.deleteResource({ key, item })
          .then(() => {
            if(this.groupBlocked && this.groupBlocked.groups.length === 0 && this.groupBlocked.searches.length === 0) {
              this.notifyStoreSuccess(this.$t('booleanSearch.delete_success_message'))
              if(key === 'search' || key === 'group' || key === 'tagSearch') {
                let url = `/clients/${this.$route.params.client_id}/projects/${this.$route.params.project_id}/`
                if(key === 'group') url += 'searches/group_library/';
                else if(key === 'tagSearch') url += 'tags/';
                else url += 'searches/';
                this.$router.push(url)
              }
            }

            resolve()
          })
          .catch(() => {
            this.notifyStoreError()
            reject()
          });
      })
    }
  },

  computed: {
    ...mapState({
      groupBlocked: state => state.group_blocked
    })
  },
}